<template>
  <div>
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>
    <div class="item-info">
      <ul class="item-ul">
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">出库单号：</span
              >{{ list.ioDataNo }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">来源单号：</span
              >{{ list.externalNo }}</span
            >
          </div>
          
        </li>
        <li class="item-li">
           <div class="item-left">
             <span
              ><span style="color: #000">申请用户：</span
              >{{ list.applicationUser }}</span
            >
          </div>
          <div class="item-right">
            <span
              ><span style="color: #000">申请时间：</span
              >{{ list.applicationTime }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">部门：</span
              >{{ list.department }}</span
            >
          </div>
          <div class="item-right">
            <span
              ><span style="color: #000">种类\PCS数：</span>{{ list.qty }}\{{
                list.quantity
              }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <p style="margin: 5px 0">
            原因：<span style="color: #3d5064">{{
              list.applicationReason
            }}</span>
          </p>
        </li>
      </ul>
    </div>

    <div class="list" style="font-size: 13px">
      <van-row type="flex" justify="left" align="left">
        <van-col span="9">SKU</van-col>

        <van-col span="4">应出数量</van-col>
        <van-col span="11">实出数量</van-col>
      </van-row>
      <div>
        <van-swipe-cell v-for="(item, index) in dataItemList" :key="index">
          <div class="list-div" @click="openModel(item)">
            <van-col
              span="9"
              style="
                background-color: #fff !important;
                height: 100%;
                word-break: normal;
              "
              >{{ item.sku }}</van-col
            >
            <van-col
              span="4"
              style="
                background-color: #fff !important;
                height: 100%;
                word-break: normal;
              "
              >{{ item.quantity || 0 }}</van-col
            >
            <van-col
              span="11"
              style="
                background-color: #fff !important;
                height: 100%;
                word-break: normal;
                line-height: 32px;
              "
            >
              <div
                v-if="item.outboundList.length > 0"
                style="
                  line-height: 20px;
                  float: left;
                  margin-left: 2%;
                  width: 60%;
                  min-width: 90px;
                "
              >
                <van-swipe-cell
                  v-for="(itemdis, indexs) in item.outboundList"
                  :key="indexs"
                >
                  <p v-if="item.outboundList.length > 1" style="margin: 0">
                    <span>{{ itemdis.locationCode }}</span
                    ><span style="margin-left: 3%">{{
                      itemdis.newOutQty
                    }}</span>
                  </p>
                  <p v-else>
                    <span>{{ itemdis.locationCode }}</span
                    ><span style="margin-left: 3%">{{
                      itemdis.newOutQty
                    }}</span>
                  </p>
                </van-swipe-cell>
              </div>
              <van-button
                plain
                hairline
                size="small"
                type="info"
                style="line-height: 25px"
                >选择</van-button
              >
            </van-col>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="清零"
              @click="toDelete(index)"
            />
          </template>
        </van-swipe-cell>
      </div>
      <div class="submit-box">
        <button class="submit-btn" @click="submit">确认出库</button>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :title="`SKU：${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="返回"
      :before-close="confirm"
    >
      <div class="list">
        <van-row type="flex" justify="center" align="center">
          <van-col span="8">库位</van-col>
          <van-col span="8">数量</van-col>
          <van-col span="8">出库数量</van-col>
        </van-row>
        <div  style="max-height: 240px;overflow-y: scroll;">
          <van-swipe-cell
            v-for="(item, index) in inventoryList"
            :key="index"
            style="font-size: 13px;"
          >
            <div class="list-div">
              <p>{{ item.locationCode }}</p>
              <p>{{ item.enableQty || 0 }}</p>
              <p style="margin-right: 2px">
                <van-field v-model="item.newOutQty" type="digit" />
              </p>
            </div>
          </van-swipe-cell>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  getStockIODataDetailed,
  miscellaneousIssue,
} from "@/api/mobile/otherExWarehouse";
// import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: {},
      dataItemList: [],
      scanLocationCode: "",
      show: false,
      saveLocationCode: "",
      isAutoOpen: false,
      inventoryList: [], //库存明细
      rowInventory: [], //选择的SKU
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  // mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    // document.querySelector('.van-field__right-icon').style.color = '#ffffff'
    // document.querySelector('.van-field__control').style.color = '#ffffff'
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
      this.getList();
    },

    triggerSearch() {
      this.$refs.searchBtn.click();
    },

    getList() {
      const that = this;

      const { stockIODataID } = this.$route.query;

      const data = {
        stockIODataID: stockIODataID,
      };
      console.log(data);
      getStockIODataDetailed(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.list = response.dataList;
          this.dataItemList = response.dataItemList;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(row) {
      this.show = !this.show;
      this.rowInventory = {};
      this.inventoryList = [];
      this.rowInventory = row;
      this.inventoryList = row.inventoryList;
      this.saveLocationCode = row.sku + "(" + row.quantity + ")";
      this.isAutoOpen = false;
    },

    confirm(action, done) {
      if (action === "confirm") {
        let row = this.rowInventory;
        let totalSumAll = 0;
        row.inventoryList.map((item) => {
          totalSumAll += parseInt(item.newOutQty == "" ? 0 : item.newOutQty);
        });
        console.log(totalSumAll);
        if (row.quantity !== totalSumAll) {
          Toast("出库数量与应出数量不相等");
          return done(false);
        }

        let outList = row.inventoryList.filter((m) => {
          return m.newOutQty > 0;
        });

        outList.forEach(function (item, index) {
          item.newOutQty = parseInt(item.newOutQty == "" ? 0 : item.newOutQty);
        });

        const index = this.dataItemList.findIndex(
          (item) => item.stockIODataItemID === row.stockIODataItemID
        );
        this.dataItemList[index].outboundList = [];
        this.dataItemList[index].outboundList = JSON.parse(
          JSON.stringify(outList)
        );

        console.log(this.dataItemList);
        return done();
      } else {
        return done();
      }
    },

    toDelete(i) {
      this.$set(this.dataItemList[i], "outboundList", []);
      this.dataItemList[i].inventoryList.map((item) => {
        item.newOutQty = 0;
      });
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;

      let outboundList = [];
	  for(let i=0;i<this.dataItemList.length;i++)
	  {
       let totalSumAll = 0;
        this.dataItemList[i].outboundList.map((itemSum) => {
          totalSumAll += parseInt(
            itemSum.newOutQty == "" ? 0 : itemSum.newOutQty
          );
          outboundList.push(itemSum);
        });
    	 console.log(this.dataItemList[i].quantity,totalSumAll);
        if (parseInt(this.dataItemList[i].quantity) !== parseInt(totalSumAll)) {
          this.showsound(false);
          Toast("SKU：" +  this.dataItemList[i].sku + "实出数量与应出数量不相等");
          return false;
        }

	  }
      this.dataItemList.forEach(function (item, index) {
       
      });

      let obj = {};
      obj.stockIODataID = this.list.stockIODataID;
      obj.outboundList = outboundList;

      Toast.loading({
        message: " 出库中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      miscellaneousIssue(obj).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success(res.msg);
          setTimeout(function () {
          that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.submit-box {
  position: static;
  margin: 20px 0;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
}
.list {
   height: 50%;
  .list-div {
    display: flex;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>